export class Profesional {
    id: number;
    dni: string;
    clave: string;
    numeroColegiado: number;
    nombre: string;
    apellidos: string;
    correo: string;
    codigoCentro: number;
    codigoAgenda: number;
    cambioClave: boolean;
}



// WEBPACK FOOTER //
// ./src/models/profesional.ts